import React from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');
  const localData = useSelector((state) => state.localRedux);
  const Role = localData?.MultiverseRole
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1
              ? 'home'
              : mainPathSplit.length === 2
                ? mainPathSplit[1]
                : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >

      <Menu.Item key="home" icon={
        <NavLink className="menuItem-iocn" to={`${path}`}>
          <FeatherIcon
            // stroke="#4379F2" 
            icon="folder" />
        </NavLink>
      }          >
        <NavLink onClick={toggleCollapsed} to={`${path}`}>
          {(Role === 'Proof Reader' || Role === 'Translator' || Role === 'Reviewer') ? "Jobs" :
            (Role === 'Multivrse Admin' || Role === 'Standard User' || Role === 'Requester' || Role === 'Customer Admin' || Role === 'Requester and Reviewer') ? "Projects" : ""}
        </NavLink>
      </Menu.Item>
      {Role === 'Multivrse Admin' &&
        <Menu.Item key="account" icon={
          <NavLink className="menuItem-iocn" to={`${path}/account`}>
            <FeatherIcon icon="smile" />
          </NavLink>
        }          >
          <NavLink onClick={toggleCollapsed} to={`${path}/account`}>
            Customers
          </NavLink>
        </Menu.Item>
      }
      {(Role === 'Multivrse Admin') && //  || Role === 'Standard User'
        <Menu.Item key="internal-users" icon={
          <NavLink className="menuItem-iocn" to={`${path}/internal-users`}>
            <FeatherIcon icon="user" />
          </NavLink>
        }          >
          <NavLink onClick={toggleCollapsed} to={`${path}/internal-users`}>
            Staff Users
          </NavLink>
        </Menu.Item>
      }

      {Role === 'Customer Admin' && (
        <>
          <Menu.Item key="users" icon={
            <NavLink className="menuItem-iocn" to={`${path}/users`}>
              <FeatherIcon icon="user" />
            </NavLink>}>
            <NavLink onClick={toggleCollapsed} to={`${path}/users`}>
              Users
            </NavLink>
          </Menu.Item>
        </>
      )}
      {/* {(Role === 'Requester' || Role === 'Reviewer' || Role === 'Requester and Reviewer' || Role === 'Customer Admin') &&
        <Menu.Item key="reports" icon={
          <NavLink className="menuItem-iocn" to={`${path}/reports`}>
            <FeatherIcon icon="pie-chart" />
          </NavLink>}>
          <NavLink onClick={toggleCollapsed} to={`${path}/reports`}>
            Reports
          </NavLink>
        </Menu.Item>
      } */}
    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
